import * as R from 'ramda';

const retrieveDeviceRecordsByPatientId = {
  fe2be: R.identity,
  be2fe: ({ value: { deviceRecords, user } }) => (
    {
      list: deviceRecords,
      patientInfo: user,
    }
  ),
};

const createReturnOrReplaceDeviceRecord = {
  fe2be: R.identity,
  be2fe: R.identity,
};

export default {
  retrieveDeviceRecordsByPatientId,
  createReturnOrReplaceDeviceRecord,
};
